module.exports = "/static/assets/0f3aeb82f652b7b9c5b586cc50d052e4.png";